import { createClient } from '@/shared/api';
import type {
  SubmitSupportRequestMutation,
  SubmitSupportRequestMutationVariables,
} from '@/shared/api';
import SUBMIT_SUPPORT_REQUEST_MUTATION from '../mutations/submitSupportRequest';

/**
 * Submits a new clinic support request ticket. Runs SUBMIT_SUPPORT_REQUEST_MUTATION and throws submitSupportRequest.message when isSuccess is false.
 *
 * @param input - Mutation input payload.
 * @returns A promise resolving once the mutation result has been checked for success.
 */
const handleSubmitSupportRequest = async (
  input: SubmitSupportRequestMutationVariables['input'],
): Promise<void> => {
  const client = createClient();
  const submitSupportRequestResult = await client.mutate<
    SubmitSupportRequestMutation,
    SubmitSupportRequestMutationVariables
  >({
    mutation: SUBMIT_SUPPORT_REQUEST_MUTATION,
    variables: { input },
  });
  const { data } = submitSupportRequestResult;
  // data is guaranteed by the mutation contract; downstream code already assumes it exists
  const { submitSupportRequest } = data!;
  if (!submitSupportRequest.isSuccess) {
    throw new Error(submitSupportRequest.message ?? undefined);
  }
};

export default handleSubmitSupportRequest;
